import { RICH_TEXT_FONT_OPTIONS } from "@/fontFamily";

/** Font-family options sourced from the shared editor font list (src/fontFamily.ts). */
const FONT_FAMILY_OPTIONS = RICH_TEXT_FONT_OPTIONS.filter(
  (opt) => opt.id && opt.cssValue
).map((opt) => ({ label: opt.label, value: opt.cssValue }));

const DEFAULT_FONT_FAMILY = "var(--font-poppins), Poppins, sans-serif";

/** Restricted font sizes 14px–32px (per spec). */
const FONT_SIZE_OPTIONS = Array.from({ length: 32 - 14 + 1 }, (_, i) => {
  const size = 14 + i;
  return { label: `${size}px`, value: String(size) };
});

const FONT_WEIGHT_OPTIONS = [
  { label: "Light (300)", value: "300" },
  { label: "Regular (400)", value: "400" },
  { label: "Medium (500)", value: "500" },
  { label: "Semi Bold (600)", value: "600" },
  { label: "Bold (700)", value: "700" },
  { label: "Extra Bold (800)", value: "800" },
];

const HEADING_TAG_OPTIONS = [
  { label: "H1", value: "h1" },
  { label: "H2", value: "h2" },
  { label: "H3", value: "h3" },
  { label: "H4", value: "h4" },
  { label: "H5", value: "h5" },
  { label: "H6", value: "h6" },
];

export const HEADING_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    content: "",
    heading_tag: "h2",
    font_family: DEFAULT_FONT_FAMILY,
    desktop_font_size: "32",
    mobile_font_size: "24",
    font_weight: "600",
    line_height: "1.2",
    text_color: "#111111",
    background_color: "#FFFFFF",
    word_break: true,
    status: true,
  },

  HEADING_FIELDS_CONFIG: [
    {
      fieldName: "content",
      label: "Content",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter heading text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "heading_tag",
      label: "Heading Tag",
      value: "h2",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select heading tag",
      required: false,
      defaultValue: "h2",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: HEADING_TAG_OPTIONS,
    },
    {
      fieldName: "font_family",
      label: "Font Family",
      value: DEFAULT_FONT_FAMILY,
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select font family",
      required: false,
      defaultValue: DEFAULT_FONT_FAMILY,
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: FONT_FAMILY_OPTIONS,
    },
    {
      fieldName: "desktop_font_size",
      label: "Desktop Font Size",
      value: "32",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select desktop font size",
      required: false,
      defaultValue: "32",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: FONT_SIZE_OPTIONS,
    },
    {
      fieldName: "mobile_font_size",
      label: "Mobile Font Size",
      value: "24",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select mobile font size",
      required: false,
      defaultValue: "24",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: FONT_SIZE_OPTIONS,
    },
    {
      fieldName: "font_weight",
      label: "Font Weight",
      value: "600",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select font weight",
      required: false,
      defaultValue: "600",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: FONT_WEIGHT_OPTIONS,
    },
    {
      fieldName: "line_height",
      label: "Line Height",
      value: "1.2",
      valueType: "string",
      filedType: "INPUT",
      placeholder: 'e.g. 1.2, normal, 150%',
      required: false,
      defaultValue: "1.2",
    },
    {
      fieldName: "text_color",
      label: "Text Color",
      value: "#111111",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#111111",
      required: false,
      defaultValue: "#111111",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "word_break",
      label: "Break Long Words",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Break words wider than the container",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [],
};
